import React from "react";
import { BrandContext } from "./BrandContext";

export const useBrand = () => {
  return React.useContext(BrandContext);
};
